import { render } from "./TimeSpentChart.vue?vue&type=template&id=e2c8c868&ts=true"
import script from "./TimeSpentChart.vue?vue&type=script&lang=ts"
export * from "./TimeSpentChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__